import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const productPageCrossSell: ComponentTemplate = {
  id: "6894c921-275d-40de-8983-90393536cba4",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Rebuy/Rebuy Product Page Cross-sell",
  leftBarCategory: { main: "pageIntegrations", subCategory: "rebuy" },
  preview: "rebuy/product-page-cross-sell.svg",
  transforms: [],
  template: {
    id: "$uid",
    type: "rebuyWidget",
    props: {
      style: {
        alignSelf: "stretch",
        flexGrow: 1,
      },
    },
  },
};
